/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */

import { useLocation } from "react-router-dom";
import { useReadLocalStorage } from "usehooks-ts";

import { TTL, TTL_KEY } from "@/constants";

export const useRestartForm = () => {
  const location = useLocation();
  const ttl = useReadLocalStorage<number>(TTL_KEY) ?? TTL;

  // this caters for a case customer knows the url of a certain screen
  // without fill in any previous screens.
  const isNoHistoryState = () =>
    !location.state || Object.keys(location.state?.data ?? {}).length == 0;

  const isTTLExpired = (ttl: number, createdAt: number, now: number) => {
    return now - createdAt > ttl;
  };

  // this caters for a case customer let the form in inactive mode
  const isFormExpired = () => {
    const now = Date.now();
    const rs = isTTLExpired(ttl, location.state.createdAt, now);
    return rs;
  };

  const isInHardStopScreen = (hardStopScreenName: string) =>
    location.pathname.includes(hardStopScreenName);

  const isHardStop = () => !!location.state.data["hardStop"];

  const isHardStopDetected = (hardStopScreenName: string) =>
    !isInHardStopScreen(hardStopScreenName) && isHardStop();

  return {
    isNoHistoryState,
    isFormExpired,
    isHardStopDetected,
  };
};
